"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HapticFeedbackType = void 0;
var HapticFeedbackType;
(function (HapticFeedbackType) {
    HapticFeedbackType["Success"] = "feedbackSuccess";
    HapticFeedbackType["Warning"] = "feedbackWarning";
    HapticFeedbackType["Light"] = "feedbackLight";
    HapticFeedbackType["Medium"] = "feedbackMedium";
    HapticFeedbackType["Heavy"] = "feedbackHeavy";
    HapticFeedbackType["Error"] = "feedbackError";
})(HapticFeedbackType || (exports.HapticFeedbackType = HapticFeedbackType = {}));
//# sourceMappingURL=user-interaction.channel.interfaces.js.map